import { render } from "./DataSourcesPhotosTable.vue?vue&type=template&id=4b59886f&ts=true"
import script from "./DataSourcesPhotosTable.vue?vue&type=script&lang=tsx"
export * from "./DataSourcesPhotosTable.vue?vue&type=script&lang=tsx"

import "./DataSourcesPhotosTable.vue?vue&type=style&index=0&id=4b59886f&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__